import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useSSOContextStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/SSOContextStore";
import { useCallback, useMemo } from "react";
// ts-prune-ignore-next will use in followup PR
export var useSSOMFAStore = function() {
    var _useSSOContextStore = _sliced_to_array(useSSOContextStore([
        "mfaDescription",
        "mfaTitle",
        "mfaOptions"
    ]), 2), _useSSOContextStore_ = _useSSOContextStore[0], mfaDescription = _useSSOContextStore_.mfaDescription, mfaTitle = _useSSOContextStore_.mfaTitle, mfaOptions = _useSSOContextStore_.mfaOptions, setStore = _useSSOContextStore[1];
    var showSelectMFA = useMemo(function() {
        return mfaOptions.length !== 0;
    }, [
        mfaOptions
    ]);
    var setMFADescription = useCallback(function(description) {
        setStore({
            mfaDescription: description
        });
    }, [
        setStore
    ]);
    var resetMFADescription = useCallback(function() {
        setStore({
            mfaDescription: ""
        });
    }, [
        setStore
    ]);
    var setMFATitle = useCallback(function(title) {
        setStore({
            mfaTitle: title
        });
    }, [
        setStore
    ]);
    var resetMFATitle = useCallback(function() {
        setStore({
            mfaTitle: ""
        });
    }, [
        setStore
    ]);
    var setMFAOptions = useCallback(function(options) {
        setStore({
            mfaOptions: options
        });
    }, [
        setStore
    ]);
    var resetMFAOptions = useCallback(function() {
        setStore({
            mfaOptions: []
        });
    }, [
        setStore
    ]);
    return {
        mfaDescription: mfaDescription,
        mfaTitle: mfaTitle,
        mfaOptions: mfaOptions,
        showSelectMFA: showSelectMFA,
        setMFADescription: setMFADescription,
        resetMFADescription: resetMFADescription,
        setMFATitle: setMFATitle,
        resetMFATitle: resetMFATitle,
        setMFAOptions: setMFAOptions,
        resetMFAOptions: resetMFAOptions
    };
};
